import {
  browserTracingIntegration,
  init,
  replayIntegration,
} from "@sentry/react";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// Sentry
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

init({
  dsn: __SENTRY_DSN__,
  integrations: [browserTracingIntegration(), replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", __SENTRY_TRACE_PROPAGATION_TARGET__],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  release: __NODE_ENV__ === "production" ? __APP_VERSION__ : undefined,
  enabled: __NODE_ENV__ === "production",
});
